import React from 'react';
import Mercado   from './Mercado.jsx';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import  '../../styles/style.css';
import json from '../../siee.json';
import Grid from '../gridreportes.jsx';
function  reportemanifiesto () {
   return <div >
      <div className="pagetitle">
           <h1>Manifiesto con Fecha de venta</h1>
       </div>
            <Mercado></Mercado> 
            <div style={{flexDirection: 'row'}}>
            <p >Fecha Inicio</p>
            <DatePicker  weekNumber={true}   id='fh_Inicio' width={200} value={new Date()} format="dd/MM/yyyy"/>
            <p>Fecha Fin</p>
            <DatePicker  weekNumber={true}  id='fh_Inicio'  width={200} value={new Date()} format="dd/MM/yyyy"/>
            </div>
            <Grid dato={json}></Grid>
            </div>
           
          };
export default reportemanifiesto;